<template>
  <div class="main-content" v-loading="isLoading">
    <div class="max-w-7xl mx-auto px-5">
      <div v-if="!failMessage && totalAmountToPay > 0">
        <div class="flex justify-center pb-1">
          <img style="width: 30%" src="pocket_logo.png" alt="pocket logo"/>
        </div>


        <div class="grid grid-cols-1 pr-4 pl-4">
          <div class="bg-white rounded-md">
            <div class="font-semibold mb-2 text-center text-[18px]">Нийт төлөх дүн</div>
            <h1 class="flex justify-center mb-4 font-bold text-[42px] pb-2  text-[#E33054]">
              {{ getCurrency(totalAmountToPay) }}</h1>
            <div class="font-semibold text-[12px] pb-2 text-transform: uppercase">төлөлтийн дэлгэрэнгүй жагсаалт</div>
            <br/>
            <div>
              <ul v-if="loans">
                <li v-for="(item, index) in loans" :key="index">
                  <div class="flex justify-between">
                  <span class="productDescription text-sm pb-3 font-semibold text-[14px] text-[#808080]">{{
                      item.productDescription
                    }}</span>
                    <span class="exDaysDescription font-semibold  text-[14px]"> {{
                        getCurrency(item.amountToPay)
                      }} </span>
                  </div>
                  <hr>
                  <div class="flex justify-end font-medium text-[12px] pb-3" style="color: rgba(89%, 19%, 33%, 0.46)">
                    <div class="amountToPay">{{ item.exDaysDescription }}</div>
                  </div>

                </li>
              </ul>
              <br/><br/><br/>
            </div>
          </div>
        </div>


        <Teleport to=".outer-container">
          <div class="text-center fixed p-4 inset-0 bottom-0 top-auto pr-8 pl-8 pt-20">
            <button class="bg-[#E33054] text-white font-medium py-2 px-4 rounded-md w-full" @click="pay">Төлөх</button>
          </div>
        </Teleport>

      </div>
      <div v-else>
        <div class="flex items-center justify-center h-screen">
          <p class="text-center font-medium text-[14px]">{{ failMessage }}</p>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

import _ from 'lodash';
import api from '@/services/api';

export default {
  name: 'Info-detail',
  data() {
    return {
      encoded: null,
      totalAmountToPay: 0,
      loans: [],
      customerId: 0,
      isLoading: false,
      failMessage: null
    };
  },
  mounted() {
    this.encoded = this.$route.params.encoded;
    console.log(this.encoded);
    this.fetchData();
  },
  methods: {

    getCurrency(value) {
      return `${parseFloat(_.ceil(value, 2)).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}₮`;
    },

    async fetchData() {
      try {
        this.isLoading = true;
        const response = await api.getLoansInfo(this.encoded);
        this.failMessage = response.data.failMessage;
        this.loans = response.data.loans;
        this.totalAmountToPay = response.data.totalAmountToPay;
        this.customerId = response.data.customerId;
      } catch (error) {
        console.log(error);
      }
      this.isLoading = false;
    },
    async pay() {
      this.$router.push(`/pay/${this.encoded}`);
    },
  },
};
</script>
